//@flow
import {
  createProductsBatchApi,
  updateProductsBatchApi,
  getProductsBatchUploadStatusApi,
} from './api';

import type {
  CreateBatchProductsRequest,
  ProductBatchLoadTask,
} from '../../entities';

export function createProductsBatchService(
  request: CreateBatchProductsRequest
): Promise<ProductBatchLoadTask> {
  const {fileId} = request;
  return createProductsBatchApi({
    taskType: 'CREATE',
    fileId,
  }).toPromise();
}

export function updateProductsBatchService(
  request: CreateBatchProductsRequest
): Promise<ProductBatchLoadTask> {
  const {fileId} = request;
  return updateProductsBatchApi({
    taskType: 'EDIT',
    fileId,
  }).toPromise();
}

export function getProductsBatchCreateStatusService(): Promise<ProductBatchLoadTask> {
  return getProductsBatchUploadStatusApi({
    type: 'CREATE',
  }).toPromise();
}

export function getProductsBatchEditStatusService(): Promise<ProductBatchLoadTask> {
  return getProductsBatchUploadStatusApi({
    type: 'EDIT',
  }).toPromise();
}
